import { apiSlice } from "./apiSlice";

export const purposesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPurposes: builder.query({
      query: ({geomedia, geodata}) => {
        return `/purposes?geomedia=${geomedia}&geodata=${geodata}`
      },
      providesTags: (result = [], error, arg) => [{ type: 'Purposes', id: JSON.stringify(arg) }],
    }),
  }),
  overrideExisting: false
})

export const {
  useLazyGetPurposesQuery,
} = purposesApiSlice
